<template>
  <div class="cmp-distribution-statement-statement_list dt-page">
    <div class="dt-page--top-bar v1">
  
      <div class="search">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth:'200px',
            minWidth:'200px',
            width:'200px'
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <!-- :selected="periodsTV.find(e => e.value == filter.selectedMonths.value)" -->
        <!-- <Dropdown
          :options="periodsTV"
          v-if="periodsTV && periodsTV.length > 0"
      
          :placeholder="'Periods'"
          deselect
          deselectLabel="Periods"
          v-on:selectedChange="e => onDropdownChange('keyword', e)"
          borderbottom
        ></Dropdown> -->

        <Dropdown
          :options="artistTV"
          style="margin-top:-1px;margin-left:20px;min-width:200px"
          :placeholder="$t('artist')"
          deselect
          borderbottom
          :selected="
            artistTV.find(e => e.value == basicFilter.artist)
          "
          :listHeight="260"
          v-on:selectedChange="e => onDropdownChange('artist', e)"
        />

        <Dropdown
          :options="labelTV"
          style="margin-top:-1px;margin-left:20px;min-width:200px"
          :placeholder="$t('label')"
          deselect
          borderbottom
          :selected="
            labelTV.find(e => e.value == basicFilter.label_id)
          "
          v-on:selectedChange="e => onDropdownChange('label_id', e)"
        />

        <Dropdown
          :options="typeTV"
          style="margin-top:-1px;margin-left:20px;min-width:200px"
          :placeholder="'Type'"
          deselect
          borderbottom
          :selected="
            typeTV.find(e => e.value == basicFilter.release_type)
          "
          v-on:selectedChange="e => onDropdownChange('release_type', e)"
        />
        
        <Dropdown
          style="margin-top:-1px;margin-left:20px;min-width:200px"
          :placeholder="$dft.capHead($t('status'))"
          :options="statusTV"
          deselect
          borderbottom
          :selected="statusTV.find(e => e.value == basicFilter.status)"
          v-on:selectedChange="e => onDropdownChange('statusTV', e)"
        />

       
      </div>
      <!-- <div class="search-config--container">
          <div class="search-config">
            <SearchConBadge
              v-for="sconKey of filteredAdvancedSearchConfigKeys"
              :key="sconKey"
              v-bind="searchConfigKey(sconKey)"
              @delete="onSearchConDelete"
            />
          </div>
      </div> -->
      <!-- <div class="right-container ut-colcen">
        <div class="ut-flex">

          <button
            class="dt-button v5 s8"
            @click="onRefresh"
          >
            {{ $t("Refresh") }}
          </button>
        </div>
      </div> -->
    </div>

    <div class="dt-page--body" :style="{ '--offset': '120px' }">
      <NTable
        id="distribution-statement-statement_list"
        class="h1"
        :config="tableConfig"
        :headers="contactHeaders"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onDistributionStatementNext"
      >
        <!-- @click="onClickStatement(item)" -->
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('release')" >
              <span @click="onClickRelease(item)" style="font-weight: bold;">{{ item["release_title"] }}</span>
            </td>
           
            <td v-bind="tdcon('artist')">
              <span>{{item['release_artist']}}</span>
            </td>
            <td v-bind="tdcon('release_date')">
              <span>{{item['release_date']}}</span>
            </td>
            <td v-bind="tdcon('type')">
              <span>{{ item["release_type"] }}</span>
            </td>
            <td v-bind="tdcon('release_catalog_nos')">
              <span>{{ item["catalog_list"] }}</span>
            </td>

          </tr>
        </template>
      </NTable>
    </div>

  </div>
</template>

<script>
// import Modal from '../../../../dt-plugins/modal/modal';
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
//import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

// import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
// import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";

import { createTV, tv } from "../../../../models/text-value.model";

import { mapGetterObject, mapActionObject } from "../../../../store/global";



import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";


// import { distributionStatementsGetters } from '../../store/statement/getters';
// import { distributionStatementsActions } from '../../store/statement/actions';

import { distributionReleaseReportGetters } from '../../store/release_report/getters';
import { distributionReleaseReportActions } from '../../store/release_report/actions';
import { baseUrl, clientName } from "../../../../services/http/http-client";


export default {
  components: {
    NTable,
    ModalContainer,

  },
  mounted: function() {},
  data: function() {
    return {
      selectedClickedLicenceAccount: null,
      selectedStatement:null,
    };
  },
  mixins: [
   

    createFetchListMixin(ActionTypes.DistributionReleaseReportList.FETCH.ALL),

  ],
  watch: {
    $route: {
      immediate: true,
      handler: function(to, from) {}
    }
  },
  computed: {
    ...mapGetterObject(storeNS, distributionReleaseReportGetters),

    artistTV:function(){
      return createTV(this.distributionReleaseReportList?.artists||[],'release_artist','release_artist');
    },

    labelTV:function(){
      return createTV(this.distributionReleaseReportList?.labels||[],'label_name','label_id');
    },
    typeTV:function(){
      return createTV(this.distributionReleaseReportList?.types||[],'release_type','release_type');
    },
    statusTV:function(){
      return createTV(this.distributionReleaseReportList?.status||[],'status','status');
    },
    filter: function() {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter
      };
    },

    tableConfig: function() {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40
      });
    },
    list: function() {
      return this.distributionReleaseReportList?.releases || [];
    },

    contactHeaders: function() {
      return [
        createTableHeader("release", {fw:700}),
        // createTableHeader("keyword", { }),
        createTableHeader("artist", {}),
        createTableHeader("release_date", {}),
        createTableHeader("type", {}),
        createTableHeader("release_catalog_nos", {}),
      ];
    },
    advancedSearchData: function() {
      return {};
    }
  },
  methods: {
    ...mapActionObject(storeNS, distributionReleaseReportActions),
    fetchAdvancedSearchData: function() {},
    defaultBasicFilter() {
      //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: undefined,
        artist: undefined,
        label_id: undefined,
        release_type: undefined,
        statement_period_txt:undefined
      };
    },

    onDropdownChange: function(name, value) {
      // <-- Normal Form Handling Methods
      this.basicFilter[name] = value.value;

      this.fetchListReset();
    },
    onClickRelease:function(item){

      const url = `${baseUrl}/${clientName}/distribution.pl?section=reports&action=release_report&release_id=${item.release_id}`
      console.log("::::::",url)

      window.open(url);
    },
    
    onDistributionStatementNext: function(value) {
      this.scrollSubject.next(value);
    },

    onCancel: function() {
      closeModalRoute(this);
    },

  }
};
</script>

<style lang="scss">
.cmp-distribution-statement-statement_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  .invoicelist-footer {
    border-top: 1px solid var(--sprt-5);

    .invoice_status_list {
      display: flex;
      .status {
        margin-top: 15px;
        display: flex;
        // max-width: 150px;
        flex: 0.5;
        .circle {
          width: 15px;
          height: 15px;

          margin-right: 10px;
          margin-top: 2.5px;
        }
        .status-name {
          flex: 1;
        }
      }
    }
  }
}
</style>
